import { Box } from "@mui/material";
import React from "react";
import { matchPath, useLocation } from "react-router-dom";
import { Layout } from "../../components";
import { useAppDispatch } from "../../redux";
import { useLazyGetUserPreferencesQuery } from "../../redux/services";
import { setUserPreferences } from "../../redux/slices/auth";
import { closeBackdrop, openBackdrop } from "../../redux/slices/backdrop";
import { AppRoutes } from "../../router/routes";
import { LocalStorageKeys, parseJwt } from "../../utils";
import { BasicDetails } from "./basicDetails";
import { NavBars } from "./utils";

export const ViewSettings: React.FC<{ children?: JSX.Element, currentPath: string }> = (props) => {

    const location = useLocation();
    const dispatch = useAppDispatch();
    const [getUserPreferences] = useLazyGetUserPreferencesQuery({ refetchOnReconnect: true, refetchOnFocus: true });

    const [currentPath, setCurrentPath] = React.useState<string>(props.currentPath);

    const token = localStorage.getItem(LocalStorageKeys.authToken) || "";

    const data = token ? parseJwt(token) : {};

    // const creatable = React.useMemo(() => HasAccess(perm, PERMISSIONS.PROPOSAL_CREATE), [perm]);
    // const readable = React.useMemo(() => HasAccess(perm, PERMISSIONS.PROPOSAL_READ), [perm]);
    // const updatable = React.useMemo(() => HasAccess(perm, PERMISSIONS.PROPOSAL_UPDATE), [perm]);
    // const deletable = React.useMemo(() => HasAccess(perm, PERMISSIONS.PROPOSAL_DELETE), [perm]);
    // const publishable = React.useMemo(() => HasAccess(perm, PERMISSIONS.PROPOSAL_PUBLISH), [perm]);

    const giveMeComponent = () => {
        // Basic Details
        if (matchPath(location.pathname, AppRoutes.currencySettings)) {
            return <BasicDetails refetch={refetch} />
        }

        return <></>
    };

    const refetch = async () => {
        dispatch(openBackdrop("Fetching User Preference Details..."));
        await getUserPreferences({ user_id: data?.sub })
            .unwrap()
            .then((res) => {
                if (res.length > 0) {
                    dispatch(setUserPreferences(res));
                }
            })
            .catch((error) => {
                console.error("User Preference Error: ", JSON.stringify(error))
            })
            .finally(() => {
                dispatch(closeBackdrop());
            });
    }

    React.useEffect(() => {
        setCurrentPath(props.currentPath);
        // eslint-disable-next-line
    }, [props.currentPath]);

    return (
        <Box
            sx={{
                p: 0.5,
                height: "100%"
            }}>
            <Layout
                history={[
                    { label: "User Module", path: '' }
                ]}
                currentPath={currentPath}
                navBars={NavBars()}
                mainPanel={giveMeComponent()}
                sideNavVariant={"whiteboard"}
                resizable
            />
        </Box>
    );
};